import VehicleDetail from './container';
export default VehicleDetail;
